module.exports = __webpack_public_path__ + "img/quantum-generator.6cf149dc.jpg";